export const dlInfo = {
    downloadVersion: "4.5.9",
    downloadStableLinux: "http://download.controlsystemstudio.org/release/4.5/cs-studio-4.5.9-linux.gtk.x86_64.tar.gz",
    downloadStableWindows: "http://download.controlsystemstudio.org/release/4.5/cs-studio-4.5.9-win32.win32.x86_64.zip",
    downloadStableMac: "http://download.controlsystemstudio.org/release/4.5/cs-studio-4.5.9-macosx.cocoa.x86_64.zip",
    allDownloads: "http://download.controlsystemstudio.org/release/4.5/",
    downloadDevVersion: "4.6.0",
    downloadDev: "https://openepics.ci.cloudbees.com/view/CS-Studio%204.6/",
}